/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_LeftInputs */

const vi_lot_debt_fill_left = /** @type {(inputs: Lot_Debt_Fill_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn vào kho: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Lot_Debt_Fill_LeftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_left = /** @type {((inputs: Lot_Debt_Fill_LeftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_LeftInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_left(inputs)
});